import { createReducer, on } from '@ngrx/store';
import { RequestStatus } from '../../enums/request-status.enum';
import { Feature } from '../models/feature.model';
import * as FeaturesActions from './features.actions';

export interface FeaturesState {
  features: Feature[] | null;
  status: RequestStatus;
  error: string | null;
  accountFeatureCodes: string[] | null;
  accountFeatureStatus: RequestStatus;
  accountFeatureError: string | null;
}

export const initialFeaturesState: FeaturesState = {
  features: null,
  status: RequestStatus.Idle,
  error: null,
  accountFeatureCodes: null,
  accountFeatureStatus: RequestStatus.Idle,
  accountFeatureError: null,
};

export const featuresReducer = createReducer(
  initialFeaturesState,

  on(FeaturesActions.loadFeatures, (state) => ({
    ...state,
    status: RequestStatus.Loading,
    error: null,
  })),

  on(FeaturesActions.loadFeaturesSuccess, (state, { features }) => ({
    ...state,
    features,
    status: RequestStatus.Success,
    error: null,
  })),

  on(FeaturesActions.loadFeaturesFailure, (state, { error }) => ({
    ...state,
    features: null,
    status: RequestStatus.Error,
    error,
  })),

  on(FeaturesActions.loadAccountFeatureScope, (state) => ({
    ...state,
    accountFeatureStatus: RequestStatus.Loading,
    accountFeatureError: null,
  })),

  on(FeaturesActions.loadAccountFeatureScopeSuccess, (state, { featureCodes }) => ({
    ...state,
    accountFeatureCodes: featureCodes,
    accountFeatureStatus: RequestStatus.Success,
    accountFeatureError: null,
  })),

  on(FeaturesActions.loadAccountFeatureScopeFailure, (state, { error }) => ({
    ...state,
    accountFeatureCodes: null,
    accountFeatureStatus: RequestStatus.Error,
    accountFeatureError: error,
  })),

  on(FeaturesActions.resetFeatures, (state) => ({
    ...initialFeaturesState,
    accountFeatureCodes: state.accountFeatureCodes,
    accountFeatureStatus: state.accountFeatureStatus,
    accountFeatureError: state.accountFeatureError,
  }))
);
